export default "__VITE_ASSET__DwneYU8g__"